(function() {
  const THRESHOLD = 7900;                // 79€ in centesimi
  const GIFT_VARIANT_ID = 57891419357509;    // variante del gift da aggiungere
  const DISCOUNT_CODE = '7DD5HX1D4BDJ';        // codice creato in admin
  const GIFT_FLAG = '__freegift';

  let isProcessing = false; // lock anti race-condition

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function getGiftItem(cart) {
    return cart.items.find(i => i.properties && i.properties[GIFT_FLAG]);
  }

  // Subtotale escludendo il gift stesso (per evitare loop logici)
  function getSubtotalWithoutGift(cart) {
    return cart.items
      .filter(i => !(i.properties && i.properties[GIFT_FLAG]))
      .reduce((sum, i) => sum + i.final_line_price, 0);
  }

  async function syncGift() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart = await getCart();
      const subtotal = getSubtotalWithoutGift(cart);
      const giftItem = getGiftItem(cart);
      const qualifies = subtotal >= THRESHOLD;

      if (qualifies && !giftItem) {
        // Aggiungi gift + applica codice
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            items: [{
              id: GIFT_VARIANT_ID,
              quantity: 1,
              properties: {
                [GIFT_FLAG]: 'true',
                '_locked': 'true'
              }
            }]
          })
        });

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            discount: DISCOUNT_CODE,
            attributes: {_aov_cd: 'true'}
          })
        });

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      if (!qualifies && giftItem) {
        // Rimuovi gift se sotto soglia
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: giftItem.key, quantity: 0})
        });

        // Rimuovi anche l'attribute flag (il codice sconto resta associato
        // ma diventa applicable: false in automatico, quindi innocuo)
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            attributes: {_aov_cd: ''}
          })
        });

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.error('[auto-gift] errore:', err);
    } finally {
      isProcessing = false;
    }
  }

  // Intercetta cambiamenti del carrello
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0].url;
    const promise = originalFetch.apply(this, args);

    if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
      promise.then(() => {
        // Skippa se la chiamata l'ha fatta lo script stesso
        if (!isProcessing) setTimeout(syncGift, 150);
      });
    }

    return promise;
  };

  // Check iniziale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGift);
  } else {
    syncGift();
  }
})();